import React, { useRef, useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FULL, SUMMARY, HANDOUT, ONEPAGE, SUMMARY_AND_PREFERENCES } from '../../../common/Variables';

const PrintReportMenu = ({ onItemClick }) => {
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const onClick = () => {
    if (isActive) return

    setIsActive(true)
  }

  useEffect(() => {
    const pageClickEvent = (e) => {
      if (dropdownRef.current === null || dropdownRef.current === undefined) return

      if (!dropdownRef.current.contains(e.target)) {
        setIsActive((wasActive) => !wasActive)
      }
    };

    if (isActive) window.addEventListener('click', pageClickEvent);

    return () => window.removeEventListener('click', pageClickEvent);
  }, [isActive]);

  return (
    <div className="print-report-button flex relative">
      <button
        ref={buttonRef}
        className="flex-none text-base font-black bg-sw-primary-blue text-white rounded-full py-2 px-5"
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faPrint} />
        <span className="px-2 text-xs">PRINT REPORT</span>
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
      <div
        ref={dropdownRef}
        className={`bg-white absolute top-11 text-sw-gray shadow-md border border-border-grey rounded-md ${isActive ? 'block' : 'hidden'}`}
      >
        <ul className="py-2 pl-4 pr-6 text-base text-center">
          <li className="print-menu-item py-2 hover:text-black">
            <button onClick={() => onItemClick(FULL.classValue)}>{FULL.text}</button>
          </li>
          <hr />
          <li className="print-menu-item py-2 hover:text-black">
            <button onClick={() => onItemClick(SUMMARY.classValue)}>{SUMMARY.text}</button>
          </li>
          <hr />
          <li className="print-menu-item py-2 hover:text-black">
            <button onClick={() => onItemClick(HANDOUT.classValue)}>{HANDOUT.text}</button>
          </li>
          <hr />
          <li className="print-menu-item py-2 hover:text-black">
            <button onClick={() => onItemClick(ONEPAGE.classValue)}>{ONEPAGE.text}</button>
          </li>
          <hr />
          <li className="print-menu-item py-2 hover:text-black">
            <button onClick={() => onItemClick(SUMMARY_AND_PREFERENCES.classValue)}>
              {SUMMARY_AND_PREFERENCES.text}
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default PrintReportMenu